(function() {

    'use strict';

    angular.module('Services').factory('ResellerListTable', ResellerListTable);

    function ResellerListTable($location, ClientService, TableLiteFactory, toastr) {
        return function (networkEffects) {
            let existing = null;
            const companiesListTableData = {
                tableName: 'ClientsListTable',
                optionAddOns: {
                    /*buttons: [{
                        class: 'btn-primary',
                        label: 'Add New Company',
                        tooltip: 'Onboard new company',
                        onClick: function(){
                            $location.path('/clients/company/details');
                        }
                    }]*/
                },
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noItemsView: false,
                    noTableFooter: false,
                },
                headers: [{
                    label: 'SELECT',
                    class: 'text-center',
                    width: '5%',
                    filter: {
                        type: 'checkbox',
                        onClick: function (row) {
                            mapSelected(row);
                            persistSelectedData(row);
                        },
                        onFilterChange: function (rows) {
                            rows.forEach(row=>{
                                mapSelected(row) ;
                            });
                        }
                    }
                }, {
                    label: 'Company Name',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Contact Person',
                    viewName: 'contactPerson',
                    filterName: 'contactPerson',
                    sortName: 'primaryContact',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.sortName);
                    }
                }, {
                    label: 'Email',
                    viewName: 'email',
                    filterName: 'email',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Phone',
                    viewName: 'phoneNumbers',
                    filterName: 'phone1',
                    filter: {
                        type: 'text',
                        class: 'bba-ref-no',
                        placeholder: 'Search',
                        onSubmit: function(header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: '' //optional
                        //text and inputDropdown uses `model` attribute for ng-model
                    },
                    headerFn: function() {
                        sort(this.filterName);
                    }
                }],
                data: []
            };
            const tableActions = new TableLiteFactory(companiesListTableData,
                {
                    serviceCallback: ClientService.Reseller.getAll,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 5,
                        page: 0,
                        enabled: true,
                        sort: 'id,desc'
                    }
                }
            );

            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;
            const selectedRows = [];

            function mapSelected(row) {
                if(row.isSelected){
                    const data = {
                        clientServiceProfileIds: [],
                        resellerId: row.id.toString()
                    };
                    networkEffects.push(data);
                    return false;
                }

                existing = networkEffects.find(reseller => reseller.resellerId.toString() === row.id.toString());
                if( existing > 1 ){
                    networkEffects.splice(existing, 1);
                }
            }

            function persistSelectedData(row) {
                if (row.isSelected) {
                    const foundRow = selectedRows.find(data => data.id === row.id);
                    if (!foundRow) {
                        selectedRows.push(row);
                    }
                    return;
                }

                for (let i = 0; i < selectedRows.length; i++) {
                    const foundRow = selectedRows[i];
                    if (row.id === foundRow.id) {
                        selectedRows.splice(i, 1);
                    }
                }
            }

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                if(!data)
                    return null;
                angular.forEach(data.content, function(client, index) {
                    client.phoneNumbers = {
                        type: 'multiLine',
                        list: []
                    };

                    client.id = client.id ? client.id : index;
                    client.companyNo = client.companyNo ? client.companyNo : 'N/A';
                    client.name = client.name ? client.name : 'N/A';
                    client.contactPerson = client.primaryContact ? client.primaryContact.firstName + " " + client.primaryContact.lastName : 'N/A';
                    if(client.primaryContact){
                        client.contactPerson = client.primaryContact.firstName + " " + client.primaryContact.lastName;

                        if(client.primaryContact.firstName === "" && client.primaryContact.lastName === ""){
                            client.contactPerson = "N/A";
                        }
                    }
                    client.email = client.email ? client.email : 'N/A';
                    if (client.phone1)
                        client.phoneNumbers.list.push(client.phone1);
                    if (client.phone2)
                        client.phoneNumbers.list.push(client.phone2);
                    if (!client.phone1 && !client.phone2)
                        client.phoneNumbers = 'N/A';

                    client.isSelected = !!networkEffects.find(reseller => reseller.resellerId.toString() === client.id.toString());

                    companiesListTableData.data.push(client);
                });
                /*** END - Building of Data ***/
            }

            function getSelectedRows() {
                return selectedRows;
            }

            this.getSelectedRows = getSelectedRows;
            this.tableData = companiesListTableData;
        }
    }
})();



// WEBPACK FOOTER //
// ./js/services/tables/ResellerListTable.js